import type { Variants } from 'motion/react'
import { durations, transitions } from '@/lib/motion/presets'

// The container only schedules the stagger; the item carries the movement.
export const staggerContainer: Variants = {
  hidden: {},
  shown: { transition: { staggerChildren: durations.itemStagger } },
}

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 6 },
  shown: { opacity: 1, y: 0, transition: transitions.panel },
}

// One-shot ring flash. Remount the node with a new key to replay it.
export const attentionFlash: Variants = {
  hidden: { opacity: 0 },
  shown: { opacity: [0, 1, 0], transition: transitions.attention },
}
